var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 10,
    fill: "#3000E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.701 34.6402C17.4251 34.6403 17.152 34.5861 16.8971 34.4806C16.6422 34.3752 16.4106 34.2205 16.2156 34.0256L10.6156 28.4256C10.4204 28.2306 10.2656 27.999 10.16 27.7441C10.0544 27.4892 10 27.2161 10 26.9402C10 26.6643 10.0544 26.3911 10.16 26.1362C10.2656 25.8814 10.4204 25.6498 10.6156 25.4548L16.2156 19.8548C16.6095 19.4608 17.1438 19.2395 17.701 19.2395C18.2581 19.2395 18.7924 19.4608 19.1864 19.8548C19.5803 20.2487 19.8016 20.783 19.8016 21.3402C19.8016 21.8973 19.5803 22.4316 19.1864 22.8256L15.0704 26.9402L19.1864 31.0548C19.4802 31.3485 19.6804 31.7227 19.7615 32.1302C19.8426 32.5377 19.801 32.9601 19.642 33.3439C19.483 33.7278 19.2137 34.0558 18.8681 34.2866C18.5226 34.5173 18.1164 34.6404 17.701 34.6402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.501 34.6402C34.0855 34.6404 33.6793 34.5173 33.3338 34.2866C32.9883 34.0558 32.719 33.7278 32.5599 33.3439C32.4009 32.9601 32.3593 32.5377 32.4404 32.1302C32.5215 31.7227 32.7217 31.3485 33.0156 31.0548L37.1316 26.9402L33.0156 22.8256C32.8205 22.6305 32.6658 22.3989 32.5602 22.1441C32.4546 21.8892 32.4003 21.616 32.4003 21.3402C32.4003 21.0643 32.4546 20.7911 32.5602 20.5363C32.6658 20.2814 32.8205 20.0498 33.0156 19.8548C33.4095 19.4608 33.9438 19.2395 34.501 19.2395C34.7768 19.2395 35.05 19.2938 35.3049 19.3994C35.5597 19.505 35.7913 19.6597 35.9864 19.8548L41.5864 25.4548C41.7815 25.6498 41.9363 25.8814 42.0419 26.1362C42.1476 26.3911 42.2019 26.6643 42.2019 26.9402C42.2019 27.2161 42.1476 27.4892 42.0419 27.7441C41.9363 27.999 41.7815 28.2306 41.5864 28.4256L35.9864 34.0256C35.7913 34.2205 35.5597 34.3752 35.3048 34.4806C35.0499 34.5861 34.7768 34.6403 34.501 34.6402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.301 38.8402C23.1054 38.8399 22.9108 38.8126 22.7228 38.759C22.1874 38.6059 21.7348 38.2465 21.4643 37.7598C21.1939 37.273 21.1279 36.6988 21.2808 36.1634L26.8808 16.5634C26.9521 16.2934 27.0766 16.0403 27.247 15.819C27.4174 15.5977 27.6302 15.4126 27.873 15.2745C28.1158 15.1365 28.3836 15.0482 28.661 15.0149C28.9383 14.9817 29.2194 15.0041 29.488 15.0808C29.7565 15.1575 30.0071 15.2871 30.2249 15.4618C30.4428 15.6365 30.6236 15.853 30.7568 16.0985C30.89 16.344 30.9729 16.6136 31.0007 16.8915C31.0284 17.1694 31.0004 17.45 30.9184 17.717L25.3184 37.317C25.1931 37.7555 24.9285 38.1413 24.5645 38.4161C24.2006 38.6909 23.757 38.8398 23.301 38.8402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_5",
    x: 6,
    y: 15,
    width: 40.2019,
    height: 31.8402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_5",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.42c28d1d3f39a62b5fd5ab8178d32355.svg";
export { ForwardRef as ReactComponent };